module.exports = __webpack_public_path__ + "static/media/tictac.e91bc586.webp";